import React, { useRef, useState, useEffect } from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { bank_method_icon, cash_in } from "../../../assets";

const CollectionTiles = ({
    allCollection = {},
    selectedMethod,
    setSelectedMethod,
}) => {
    const scrollRef = useRef(null);
    const [showLeft, setShowLeft] = useState(false);
    const [showRight, setShowRight] = useState(true);

    const { t, i18n } = useTranslation();
    const isRTL = i18n.language === "ar";

    const scroll = (direction) => {
        if (!scrollRef.current) return;

        const { clientWidth } = scrollRef.current;
        const scrollAmount = direction === "left" ? -clientWidth : clientWidth;
        const adjustedScroll = isRTL ? -scrollAmount : scrollAmount;

        scrollRef.current.scrollBy({
            left: adjustedScroll,
            behavior: "smooth",
        });
    };

    const checkScroll = () => {
        const el = scrollRef.current;
        if (!el) return;

        const tolerance = 5;
        const scrollLeft = isRTL ? Math.abs(el.scrollLeft) : el.scrollLeft;

        setShowLeft(scrollLeft > tolerance);
        setShowRight(scrollLeft + el.clientWidth < el.scrollWidth - tolerance);
    };

    useEffect(() => {
        checkScroll();

        const el = scrollRef.current;
        if (!el) return;

        el.addEventListener("scroll", checkScroll);
        window.addEventListener("resize", checkScroll);

        return () => {
            el.removeEventListener("scroll", checkScroll);
            window.removeEventListener("resize", checkScroll);
        };
    }, [allCollection, isRTL]);

    const handleClick = (method) => {
        if (setSelectedMethod) {
            setSelectedMethod(method);
        }
    };

    return (
        <div className="relative group mt-2">
            {/* Left Arrow */}
            {showLeft && (
                <button
                    onClick={() => scroll("left")}
                    className={`absolute top-1/2 -translate-y-1/2 bg-white/70 hover:bg-white border rounded-full shadow-md p-4 z-10 opacity-0 group-hover:opacity-100 transition
                    ${isRTL ? "right-0" : "left-0"}`}
                >
                    {isRTL ? <RightOutlined /> : <LeftOutlined />}
                </button>
            )}

            {/* Scrollable Container */}
            <div
                ref={scrollRef}
                dir={isRTL ? "rtl" : "ltr"}
                className="flex overflow-x-auto gap-4  pb-4 pt-2 scroll-smooth hide-scrollbar w-full"
            >
                {Object.entries(allCollection)
                    .filter(([method]) => method !== "Credit" && method !== "Cash")
                    .map(([method, amount]) => {
                        const isSelected = selectedMethod === method;

                        return (
                            <div
                                key={method}
                                className={`flex-shrink-0 flex flex-col items-start py-4 pr-6 pl-6 bg-[#FFFFFF] rounded-[18px] w-[270px] text-zinc-800
                transition-all duration-200 border shadow-sm ${isSelected
                                        ? "border-primaryBlue shadow-md"
                                        : "border-gray-300"
                                    }`}
                            >
                                <div className="flex flex-row items-center">
                                    <img
                                        src={bank_method_icon}
                                        alt=""
                                        className="aspect-square w-[45px]"
                                    />
                                    <h2 className="mx-4 mt-2 text-xl capitalize">{t(method)}</h2>
                                </div>
                                <p className="text-3xl py-6 font-semibold">
                                    EGP {Number(amount).toFixed(2)}
                                </p>
                            </div>
                        );
                    })}
            </div>

            {/* Right Arrow */}
            {showRight && (
                <button
                    onClick={() => scroll("right")}
                    className={`absolute top-1/2 -translate-y-1/2 bg-white/70 hover:bg-white border rounded-full shadow-md p-4 z-10 opacity-0 group-hover:opacity-100 transition
                    ${isRTL ? "left-0" : "right-0"}`}
                >
                    {isRTL ? <LeftOutlined /> : <RightOutlined />}
                </button>
            )}
        </div>
    );
};

export default CollectionTiles;
